import React, { useState, useEffect } from "react";
import logo from "../assets/resume/logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { IoSearchSharp } from "react-icons/io5";
import Box from "@mui/material/Box";
import { FaAward, FaBirthdayCake, FaCcVisa, FaCertificate, FaUser } from "react-icons/fa";
import { MdCardGiftcard, MdFavorite, MdKeyboardArrowDown, MdLeaderboard, MdPerson } from "react-icons/md";
import { SiTinyletter } from "react-icons/si";
import Modal from "@mui/material/Modal";
import { signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../FirebaseConfig";
import { useSelector, useDispatch } from "react-redux";
import { loginUser, loginModal } from "../Redux/authAction";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import login from "../assets/home/gmail.jpg";

const PricingCard = ({ title, desc, price, packageId, duration, features }) => {
  const [isHovered, setHovered] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const isLang = useSelector((state) => state.authReducer.lang);
  const userID = useSelector((state) => state.authReducer.uid);
  const pkgid = useSelector((state) => state.authReducer.packageid);
 
  // const pkgid = 6;
  const Status = useSelector((state) => state.authReducer.status);
  const email = useSelector((state) => state.authReducer.email);
  const loginModalValue = useSelector((state) => state.authReducer.loginModal);
  const dispatch = useDispatch();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const isAuthenticated = useSelector((state) => state.authReducer.isAuthenticated);

  // Duration mapping based on language
  const durationMapping = {
    year: isLang === "arabic" ? "سنة" : "year",
    month: isLang === "arabic" ? "شهر" : "month",
    week: isLang === "arabic" ? "أسبوع" : "week",
    day: isLang === "arabic" ? "يوم" : "day"
  };

  const handleOpen = () => dispatch(loginModal(true));
  const handleClose = () => dispatch(loginModal(false));

  const handleClick = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handlePayNow = () => {
    if (!isAuthenticated) {
      handleOpen();
    } else {
      console.log("Price", price, "Customer Email", email, "Package", packageId, "duration", duration);
      const url = `${api.API_URL}/paymentgateway/request.php?amount=${encodeURIComponent(price)}&customerEmail=${encodeURIComponent(email)}&userid=${encodeURIComponent(userID)}&pkgid=${encodeURIComponent(packageId)}&duration=${encodeURIComponent(duration)}`;
      window.open(url, "_blank");
    }
  };

  const handleLogin = async () => {
    try {
      if (logEmail && logPassword) {
        const userCredential = await signInWithEmailAndPassword(auth, logEmail, logPassword);
        const user = userCredential.user;
        const { displayName, email, uid } = user;
        dispatch(loginUser({ displayName, email, uid }));
        setSnackbarSeverity("success");
        setSnackbarMessage(isLang === "arabic" ? "تسجيل الدخول بنجاح!" : "Login successful!");
        setSnackbarOpen(true);
        dispatch(loginModal(false));
      } else {
        setSnackbarSeverity("error");
        setSnackbarMessage(isLang === "arabic" ? "يرجى إدخال البريد الإلكتروني وكلمة المرور." : "Please enter both email and password.");
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarSeverity("error");
      setSnackbarMessage(isLang === "arabic" ? "فشل تسجيل الدخول. تحقق من بياناتك." : "Failed to login. Please check your credentials.");
      setSnackbarOpen(true);
    }
  };

  const handleGoogleLogin = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        const { displayName, email, uid } = user;
        dispatch(loginUser({ displayName, email, uid }));
        dispatch(loginModal(false));
        window.location.href = "/category/design/Promotion Maker";
      })
      .catch((error) => {
        console.error("Google Login Error:", error.message);
      });
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "clamp(750px,100%,300px)",
    height: "600px",
    bgcolor: "background.paper",
    border: "0px solid #000",
    boxShadow: 24,
    p: 4
  };

  return (
    <>
      <div className={`cards p-6 h-[500px] rounded-lg shadow-lg transform transition-transform hover:scale-105`} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
        <div className="mb-4 text-center">
          <p className={`text-lg font-semibold mb-2 text-gray-700`}>{title}</p>
          <p className={`flex justify-center items-center text-3xl font-bold mb-4 text-black`}>
            SAR <span className="text-6xl">{price}</span>
            <span className="text-sm text-gray-500">/ {durationMapping[duration]}</span>
          </p>
          <span className={`text-lg mb-2 text-gray-500`}>{desc}</span>
          <hr className="my-4" />
          <p className="mb-4">{isLang === "arabic" ? "يمكنك تحميل:" : "You can download:"}</p>
          <ul className={`text-left space-y-5 text-[15px] text-black`}>
            {features.map((feature, index) => (
              <li key={index} className={`flex items-center w-full ${isLang === "arabic" ? "text-right flex-row-reverse" : ""}`}>
                {isLang === "arabic" ? (
                  <>
                    <span className="text-green-500 ml-2">✔</span>
                    <span>{feature}</span>
                  </>
                ) : (
                  <>
                    <span className="text-green-500 mr-2">✔</span>
                    {feature}
                  </>
                )}
              </li>
            ))}
          </ul>
          {(packageId == 1) ? (<>
            <div className="absolute bottom-4 right-0 w-full flex justify-center">
              <button
                className="focus:outline-none bg-blue-300 my-2 px-20 py-2 text-white text-lg font-semibold transition-colors"
                style={{ transition: "background-color 0.3s ease", backgroundSize: "200% auto", borderRadius: "300px" }}
              >
                {isLang !== "engqwe" ? "Free" : "مجاني"}
              </button>
            </div>
          </>) : (<>

            {
            (pkgid == 6 && packageId == 2 || pkgid == 7 && packageId ==3)?(<>
              <div className="absolute flex flex-col bottom-4 right-0 w-full justify-center px-3">
                <button
                  className="focus:outline-none bg-red-400 my-2 px-20 py-2 text-white text-lg font-semibold transition-colors"
                  style={{ transition: "background-color 0.3s ease", backgroundSize: "200% auto", borderRadius: "300px" }}
                  onClick={handleClick}
                >
                  {isLang !== "engqwe" ? "Renew It" : "تجديده"}
                </button>
                {
                  (pkgid == 6 && packageId == 2) && (<>
                  <span className="text-red-600">
                    Your Business Plan has been expired!!
                  </span>
                  <span className="text-red-600">
                    Renew it.
                  </span>
                  </>)
                }
                {
                  (pkgid == 7 && packageId == 3) && (<>
                  <span className="text-red-600">
                    Your Premium Plan has been expired!!
                  </span>
                  <span className="text-red-600">
                    Renew it.
                  </span>
                  </>)
                }
              </div>
            </>):(<>

            <div className="absolute bottom-4 right-0 w-full flex justify-center">
              {pkgid == packageId ? (
                <button
                  className="focus:outline-none bg-green-600 my-2 px-20 py-2 text-white text-lg font-semibold hover:bg-green-700 transition-colors"
                  style={{ transition: "background-color 0.3s ease", backgroundSize: "200% auto", borderRadius: "300px" }}
                >
                  {isLang !== "engqwe" ? "Subscribed" : "مشترك"}
                </button>
              ) : (
                <div className="flex flex-col">
                <button
                  onClick={handleClick}
                  className="focus:outline-none bg-purple-600 my-2 px-20 py-2 text-white text-lg font-semibold hover:bg-purple-700 transition-colors"
                  style={{ transition: "background-color 0.3s ease", backgroundSize: "200% auto", borderRadius: "300px" }}
                >
                  {isLang !== "engqwe" ? "Get Started" : "البدء"}
                </button>
               
                </div>
              )}
            </div>
            </>)
              }
          </>
          
        )

          }

        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg sm:max-w-xl md:max-w-3xl lg:max-w-4xl xl:max-w-5xl max-h-[90vh] overflow-auto relative transform transition-transform duration-500 ease-in-out p-4 sm:p-6 md:p-8">
            <button onClick={closeModal} className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="w-full h-64 md:h-auto">
                <img src="/payment/5359105.jpg" alt="Package" className="w-full h-full object-cover rounded-lg" />
              </div>

              <div className="p-4">
                <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-indigo-700">Package Details</h2>
                <table className="w-full text-left text-sm sm:text-lg">
                  <tbody>
                    <tr>
                      <td className="font-semibold py-2">Title:</td>
                      <td className="py-2">{title}</td>
                    </tr>
                    <tr>
                      <td className="font-semibold py-2">Description:</td>
                      <td className="py-2">{desc}</td>
                    </tr>
                    <tr>
                      <td className="font-semibold py-2">Price:</td>
                      <td className="py-2">{price} SAR</td>
                    </tr>
                    <tr>
                      <td className="font-semibold py-2">Duration:</td>
                      <td className="py-2">{durationMapping[duration]}</td>
                    </tr>
                    <tr>
                      <td className="font-semibold py-2">Package ID:</td>
                      <td className="py-2">{packageId}</td>
                    </tr>
                  </tbody>
                </table>

                <div className="flex justify-center mt-8">
                  {pkgid == packageId ? (
                    <button type="button" className="bg-green-600 text-white text-sm sm:text-lg px-6 sm:px-8 py-3 rounded-full shadow-md hover:bg-green-500 transition-colors">
                      Subscribed
                    </button>
                  ) : (
                    <button type="button" onClick={handlePayNow} className="bg-indigo-600 text-white text-sm sm:text-lg px-6 sm:px-8 py-3 rounded-full shadow-md hover:bg-indigo-500 transition-colors">
                      Pay Now
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
      >
        <MuiAlert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default PricingCard;
